import styled, { css } from 'styled-components'
import { selectToken } from '@caudena/web-platform/dist/tokens/utils/selectToken'
import { createTokenKey } from '@caudena/web-platform/dist/tokens/utils/createTokenKey'
import { Icon } from '@caudena/web-platform'

const LEFT_SIDEBAR_MIN_WIDTH = '72px'
const LEFT_SIDEBAR_MAX_WIDTH = '200px'

interface WithIsOpen {
  $isOpen: boolean
}

interface LogoProps extends WithIsOpen {
  $variant: 'short' | 'full'
}

export const StyledLeftSidebar = styled.div<WithIsOpen>`
  position: fixed;
  z-index: 150;
  top: 0;
  bottom: 0;
  left: 0;
  width: ${LEFT_SIDEBAR_MIN_WIDTH};
  padding: 32px 0;
  background-color: ${({ theme }) =>
    selectToken(theme, createTokenKey(['grey700']))};
  transition: width 0.3s;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      width: ${LEFT_SIDEBAR_MAX_WIDTH};
    `}
`

export const LogoLink = styled.div`
  display: inline-flex;
  margin-bottom: 16px;
  margin-left: 16px;
`

export const Logo = styled.svg<LogoProps>`
  transition:
    opacity 0.2s,
    transform 0.3s;

  ${({ $variant, $isOpen, theme }) => {
    const isVisible =
      ($isOpen && $variant === 'full') || (!$isOpen && $variant === 'short')
    return css`
      opacity: ${isVisible ? 1 : 0};
      display: ${isVisible ? 'block' : 'none'};
      transform: translateX(${$isOpen && $variant === 'full' ? '-8px' : 0});
      color: ${selectToken(theme, createTokenKey(['white']))};
      height: 20px;
    `
  }}
`

export const BottomPanel = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  height: 44px;
  align-items: center;
  justify-content: flex-end;
  padding: 10px;
  background-color: ${({ theme }) =>
    selectToken(theme, createTokenKey(['grey600']))};
  cursor: pointer;
`

export const ArrowIcon = styled.div<WithIsOpen>`
  color: ${({ theme }) => selectToken(theme, createTokenKey(['grey100']))};
  transition: transform 0.15s 0.15s;
  transform: scaleX(${({ $isOpen }) => ($isOpen ? -1 : 1)});
`

export const NavMenuSlotWrapper = styled.div`
  position: absolute;
  top: 112px;
  right: 0;
  bottom: 44px;
  left: 0;
`
